import OrganisationTypeEnum from '@constants/enums/organisation/type';

import RegistrarApi from '@packages/registrars/api';

import { Organisation } from '@/models';

export class Registrar extends Organisation {
    static name = 'Registrar';
    static entity = 'registrars';
    static Api = RegistrarApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(OrganisationTypeEnum, OrganisationTypeEnum.REGISTRAR).nullable()
        };
    }
}

export default Registrar;
